import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Routes, Route, Navigate } from 'react-router-dom';

import MskAssessment from 'Routes/sportsscience/mskassessment';  
import MskReport from 'Routes/sportsscience/mskreport';
import StrengthCondition from 'Routes/sportsscience/strengthcondition';
import MskVisualisation from 'Routes/sportsscience/mskvisualisation'; 
import MskPosture from 'Routes/sportsscience/mskposture';  
import ScVisualisation from 'Routes/sportsscience/scvisualisation';
import SsTeam from 'Routes/sportsscience/sportsscienceteam';
import FindingChart from 'Routes/sportsscience/mskfindingchart';
import InjuryChart from 'Routes/sportsscience/injurychart';
import FindingReport from 'Routes/sportsscience/mskfindingreport';
import InjuryChartReport from 'Routes/sportsscience/injurychartreport';
import InjuryProfile from 'Routes/sportsscience/injuryprofile';
import InjuryProfileReport from 'Routes/sportsscience/injuryprofilereport';
import MskComparativeReport from 'Routes/sportsscience/mskcomparativereport';
import ScComparativeReport from 'Routes/sportsscience/sccomparativereport';
import StudentMSKReport from 'Routes/sportsscience/studmskreport';
import StudentFindingReport from 'Routes/sportsscience/studfindingreport';
import StudentInjuryChartReport from 'Routes/sportsscience/studinjurychartreport';
import StudentInjuryProfileReport from 'Routes/sportsscience/studinjuryprofilereport';

import AppConfig from 'Constants/AppConfig';

const Pages = () => (
  <div className="content-wrapper">
    <Helmet>
      <title>Sports Science | {AppConfig.appTitle}</title>
      <meta name="description" content="TSGA Sports Science" />
    </Helmet>

    <Routes>
      {/* Default redirect */}
      <Route index element={<Navigate to="mskassessment" replace />} />

      {/* Sports Science Routes */}
      <Route path="mskassessment" element={<MskAssessment />} />
      <Route path="strengthcondition" element={<StrengthCondition />} />
      <Route path="mskreport" element={<MskReport />} />
      <Route path="mskvisualisation" element={<MskVisualisation />} />
      <Route path="mskposture" element={<MskPosture />} />
      <Route path="scvisualisation" element={<ScVisualisation />} />
      <Route path="team" element={<SsTeam />} />
      <Route path="findingschart" element={<FindingChart />} />
      <Route path="injurychart" element={<InjuryChart />} />
      <Route path="findingreport" element={<FindingReport />} />
      <Route path="injurychartreport" element={<InjuryChartReport />} />
      <Route path="injuryprofile" element={<InjuryProfile />} />
      <Route path="injuryprofilereport" element={<InjuryProfileReport />} />
      <Route path="mskcomparativereport" element={<MskComparativeReport />} />
      <Route path="sccomparativereport" element={<ScComparativeReport />} />
      <Route path="studentmskreport" element={<StudentMSKReport />} />
      <Route path="studentfindingreport" element={<StudentFindingReport />} />
      <Route path="studentinjurychartreport" element={<StudentInjuryChartReport />} />
      <Route path="studentinjuryprofilereport" element={<StudentInjuryProfileReport />} />
    </Routes>
  </div>
);

export default Pages;
